import { render, staticRenderFns } from "./InsuranceIndicator.vue?vue&type=template&id=207c4cc0&"
import script from "./InsuranceIndicator.vue?vue&type=script&lang=js&"
export * from "./InsuranceIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports